import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Row, Col, Tabs, DatePicker, Select, Collapse, Tooltip, Button, message } from 'antd';
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';
import FileConstants from '../../../../FileConstants';
import SystemUsage from '../../AdminComponents/SystemUsage/SystemUsage';
import moment from 'moment';
import ManagedServices from '../../ManagedServices/ManagedServices';
import { InfoCircleOutlined,ArrowLeftOutlined, LeftOutlined } from '@ant-design/icons';
import SharedItemUsage from '../../SharedItemUsage/SharedItemUsage';
import SystemUsageSummary from '../../SystemUsageSummary/SystemUsageSummary';
import _, { eq, set } from "lodash" // Import the entire lodash library
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
//mport backArrow from 'C:/Users/Tintash/Desktop/All3D-Frontend/all3d-frontend/public/img/arrow-back.png'

const COMPANY_ID = localStorage.getItem("company_id");
const CUSTOMER_USERNAME = localStorage.getItem("username");
const MANAGED_CUSTOMER_USERNAME = localStorage.getItem('managed_customer_username');
const MANAGED_COMPANY_ID = localStorage.getItem('managed_company_id');
const IS_MS_PROVIDER = localStorage.getItem("is_msprovider") === 'true' ? true : false;
const DATE_FORMAT = 'MM/DD/YYYY';

const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

let uniqueProjects = []; // Global variable to store unique projects

const CustomerAccountUsage = (props) => {
    
    let start_date = new URLSearchParams(window.location.search).get("startDate");
    let end_date = new URLSearchParams(window.location.search).get("endDate");
    const [startDate, setStartDate] = useState(
        start_date ? moment(start_date, DATE_FORMAT).format(DATE_FORMAT) : moment().startOf('month').format(DATE_FORMAT)
    );

    const [endDate, setEndDate] = useState(
        end_date ? moment(end_date, DATE_FORMAT).format(DATE_FORMAT) : moment().endOf('month').format(DATE_FORMAT)
    );
    const [customerUsername, setCustomerUsername] = useState('');
    const [companyID, setCompanyID] = useState(-1);
    const [accountType, setAccountType] = useState("customer");
    const [dateFilterType, setDateFilterType] = useState('billing_date');
    const [tabKey, setTabKey] = useState('usage_details');
    const [collapseKey, setCollapseKey] = useState(["details"]);
    const [displayData, setDisplayData] = useState(true);
    const [totalCount, setTotalCount] = useState([]);
    const [summaryLoader, setSummaryLoader] = useState(true);
    const [dataType, setDataType] = useState("overall");
    const [exportedDataLoader, setExportedDataLoader] = useState(false);
    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState(-1);
    const [projectIDs, setProjectIDs] = useState([]);
    const [customerData, setCustomerData] = useState([]);
    const [requestTypeCount, setRequestTypeCount] = useState({}); // Change from [] to {}
    const [error, setError] = useState({'product_models': false,
        'product_photography': false,
        'space_models': false,
        'materials': false,
        'lifestyle_photography': false,
        'managed_services': false,
        'shared_items': false,
        'scenes': false,
        'ai_models': false});
    const [typeLoading, setTypeLoading] = useState({ 'product_models': false,
        'product_photography': false,
        'space_models': false,
        'materials': false,
        'lifestyle_photography': false,
        'managed_services': false,
        'shared_items': false,
        'scenes': false,
        'ai_models': false});
    const handlebackclick=()=>{
        props.history.goBack();
    }

    useEffect(() => {
        let username = '';
        let company_id = -1;
        if (props.account_type == 'admin') {
            setAccountType(props.account_type);
            username = props.username;
            company_id = props.company_id;
            setCustomerUsername(props.username);
            setCompanyID(props.company_id);
        } else {
            // Show data for selected customer in managed service provider account
            if (IS_MS_PROVIDER && (MANAGED_CUSTOMER_USERNAME != null)) {
                setCustomerUsername(MANAGED_CUSTOMER_USERNAME);
                if (MANAGED_COMPANY_ID != null) {
                    setCompanyID(MANAGED_COMPANY_ID);
                    company_id = MANAGED_COMPANY_ID;
                }
            } else {
                if (COMPANY_ID) {
                    company_id = COMPANY_ID;
                    setCompanyID(COMPANY_ID);
                } else if (CUSTOMER_USERNAME) {
                    username = CUSTOMER_USERNAME;
                    setCustomerUsername(CUSTOMER_USERNAME);
                }
            }
        }
        if ((company_id != -1 && props.account_type == "admin") || (IS_MS_PROVIDER && MANAGED_COMPANY_ID)) {
            fetchCustomers(company_id);
        } else {
            if (props.account_type != "admin") {
                username = CUSTOMER_USERNAME;
            }
            fetchProjectData(username, 'all');
        }
    }, []);


    const fetchCustomers = (company_id) => {
         axios
            .post(ENVIRONMENT.CUSTOMER_GET_BATCH, {
                'company_id': company_id
            })
            .then((res) => {
                setCustomerData(res.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }
    useEffect(() => {
        if (customerData?.length > 0) {
            customerData.map((customer, i) => {
                fetchProjectData(customer.customer_username, 'all', i);
            })
        }
    }, [customerData]);

    function setUniqueProjects(newProjects) {
        const combinedProjects = [...uniqueProjects, ...newProjects];
        uniqueProjects = combinedProjects.filter(
            (project, index, self) => index === self.findIndex(p => p.id === project.id)
        );
    }

    const onCalenderChange = (date_values) => {
        if (date_values) {
            if (date_values[0]) {
                setStartDate(date_values[0].format(DATE_FORMAT));
            }
            if (date_values[1]) {
                setEndDate(date_values[1].format(DATE_FORMAT));
            }
        }
    }

    const checkIfDateIsSameMonth = (new_start_date, new_end_date) => {
        if (new_start_date && new_end_date && dateFilterType == 'billing_date') {
            let start_date = moment(new_start_date, DATE_FORMAT);
            let startOfCurrentMonth = moment().startOf('month').format(DATE_FORMAT)
            let isCurrentMonthYearRange = start_date.isAfter(startOfCurrentMonth, 'day');
            setDisplayData(!isCurrentMonthYearRange);
        } else {
            setDisplayData(true);
        }
    }
    
    useEffect(() => {
        checkIfDateIsSameMonth(startDate, endDate)
    }, [endDate, startDate, dateFilterType])
   
    const onChangeDateType = (key) => {
        setDateFilterType(key);
    }

    const onChangeTab = (key) => {
        setTabKey(key);
    }

    const prepareSystemUsageCounts = (usage_counts, old_total_count, old_request_type_count, callback) => {
        let regex = /(1k|2k|3k|4k)/;
        let total_count = {};
        let request_type_count = {};
        // Initialize total count for each type of service to 0
        FileConstants.typesOfServices.map((key) => {
            if (old_total_count[key] && old_total_count[key] > 0) {
                total_count[key] = old_total_count[key];
            } else {
                total_count[key] = 0;
            }
            if (old_request_type_count[key] && old_request_type_count[key].length > 0) {
                request_type_count[key] = old_request_type_count[key];
            } else {
                request_type_count[key] = [];   
            }

        });

        let originalArray = _.cloneDeep(usage_counts); // Create a deep clone of the original usage_counts array

        // Iterate through each type of service
        FileConstants.typesOfServices.map((key) => {
            let objectsToMove = [];
            let new_object = {};

            // Iterate through each count_data object in usage_counts
            usage_counts.map(count_data => {

                // Extract the base request type without resolution value
                // e.g., for scene_lifestyle_512x321, extract 'scene_lifestyle'
                const lastIndex = count_data['request_type'].lastIndexOf('_');
                const result = count_data['request_type'].substring(0, lastIndex);
                const containsSearchString = FileConstants.SERVICES_RESOLUTION_REQUESTS[key].some(searchString => result.startsWith(searchString) && !regex.test(count_data['request_type']));
                // if request has custom res, then add custom res request data to request_type+'_custom' key in dictionary
                if (containsSearchString) {
                    if (!objectsToMove[result+"_custom"]) {
                        objectsToMove[result+"_custom"] = [];
                    } 
                    objectsToMove[result+"_custom"].push(count_data);
                    
                    
                    if (!new_object[result + "_custom"]) {
                        new_object[result+"_custom"] = {};
                    } 
                    // get total count of request
                    let totalRequestCount = objectsToMove[result+"_custom"].reduce((acc, obj) => acc + obj.request_count, 0);
                    new_object[result+"_custom"] = {
                        "request_type": result + "_custom",
                        "request_count": totalRequestCount,
                        "children": objectsToMove[result+"_custom"]
                    }

                    // Remove original objects with custom resolution from originalArray because they are being added to _custom attribute
                    objectsToMove[result+"_custom"].forEach(obj => {
                        const index = originalArray.findIndex(arrObj => arrObj.request_type === obj.request_type);
                        if (index !== -1) {
                            originalArray.splice(index, 1);
                        }
                    });

                    // Replace or add the new object to originalArray
                    originalArray = replaceObjectByRequestType(originalArray, new_object[result+"_custom"]);
                }
            });
        });

        if (originalArray.length == 0) {
            return {request_type_count, total_count};
        }
            
        // Iterate through originalArray to compute total counts and request_type_count
        originalArray.map((count_data) => {
            FileConstants.typesOfServices.map((key) => {
                const containsSearchString = FileConstants.SERVICES_RESOLUTION_REQUESTS[key].some(searchString => count_data['request_type'].startsWith(searchString) && !regex.test(count_data['request_type']));
                if (old_request_type_count[key] && old_request_type_count[key].length > 0) {
                    request_type_count[key] = old_request_type_count[key];
                } else {
                    if (!request_type_count[key]) {
                        request_type_count[key] = []
                    }
                    if (FileConstants.SERVICES_LIST[key].includes(count_data['request_type']) || (containsSearchString)) {
                        total_count[key] = total_count[key] + parseInt(count_data['request_count']);
                        request_type_count[key].push(count_data);
                    }
                }
                
            })
        })

        // Set the total count and request_type_count using provided props
        setTotalCount(total_count);
        setRequestTypeCount(request_type_count);
        callback();
        return {request_type_count, total_count};
    }


    const fetchProjectData = async (username = CUSTOMER_USERNAME, type = 'all', index = 0) => {
        let payload = {
            order_by: "id desc",
            required_fields: [
              "id",
              "name"
            ]
          };

        let filter_string = `(username__exact='${username}')&&(access_level__in=['owner','viewer','co_owner','quality_control', 'editor'])&&(is_hidden__not=true)`;
        payload.filter_string = filter_string;
              
        await axios.post(ENVIRONMENT.GET_PROJECT_BATCH, payload).then((res) => {
            if (type === 'all') {
                const newProjects = res.data || [];
                setUniqueProjects(newProjects);
                if (index == customerData.length - 1) {
                    setProjects(uniqueProjects)
                }
            } else {
                setProjects(res.data);
            }
        });
    };

    useEffect(() => {
        if (projects?.length > 0) {
            const ids = projects.map(item => item.id.toString());
            setProjectIDs(ids);
        }
    }, [projects]);


    const replaceObjectByRequestType = (array, newObject) => {
        // Find the index of the object with the matching request_type
        const index = array.findIndex(obj => obj.request_type === newObject.request_type);
        
        if (index !== -1) {
            // If an object with the same request_type exists, replace it
            array[index] = newObject;
        } else {
            // Otherwise, add the new object to the array
            array.push(newObject);
        }
        return array;
    }

    const convertToCSV = (data, includeHeaders = true) => {
        if (data.length === 0) {
            return null;
        }

        // Add extra headers for project_ids and project_names
        const header = Object.keys(data[0]).reduce((acc, key) => {
            if (key === "project_ids") {
                acc.push("project_ids", "project_names");
            } else {
                acc.push(key);
            }
            return acc;
        }, []);

        const csv = includeHeaders ? [header.join(',')] : [];

        for (const item of data) {
            const row = header.map((key) => {
                let cell = item[key];
                if (key === "project_names" && !cell && item.project_ids) {
                    // Extract project names
                    cell = JSON.parse(item.project_ids);
                    const projectNames = cell.map(p => p.name).join(',');
                    return `"${projectNames}"`;
                }
                if (cell) {
                    if (key === "project_ids") {
                        // Extract project_ids
                        cell = JSON.parse(cell);
                        const projectIds = cell.map(p => p.project_id).join(',');
                        return `"${projectIds}"`;
                    }

                    if (typeof cell === 'object' && cell !== null) {
                        // Flatten and stringify object values
                        cell = JSON.stringify(cell);
                    } else if (typeof cell !== 'string') {
                        cell = cell.toString();
                    } else if (cell === null) {
                        cell = 'NULL';
                    }

                    // Wrap the cell in double quotes and handle escaping
                    cell = `"${cell.replace(/"/g, '""')}"`;
                    cell = cell.replace(/,/g, ' , ');
                    cell = `"${cell.replace(/[\[\]"']/g, '')}"`;
                }
                return cell;
            });
            csv.push(row.join(','));
        }

        const csvString = csv.join('\n');
        return csvString;
    };
    

    const handleDownloadMultipleCSV = async (records, entityType, zip) => {
        if (records.length > 0) {
            records = records.reduce((acc, val) => acc.concat(val), []);
        }
        const combinedCSVData = records.map((record, index) => {
            const includeHeaders = index === 0;
            return convertToCSV([record], includeHeaders);
        });

        if (combinedCSVData.length > 0) {
            const combinedCSV = combinedCSVData.join('\n');
            zip.file(`${entityType}.csv`, combinedCSV);
        }
    };

    const exportedData = () => {
        setExportedDataLoader(true);
        let loader = message.loading("Please wait, while we prepare data for export...", 0);

        const zip = new JSZip();
        const promises = FileConstants.typesOfServices
        .filter((key) => key !== "managed_services" && key !== "shared_items")
        .map(async (service, index) => {
            if (totalCount[service] > 0) {
                let summary_payload = {
                    request_type: service,
                    action: "get_counts",
                    date_filter_type: dateFilterType,
                    start_date: startDate,
                    end_date: endDate,
                    data_type: "overall"
                };
                if (dataType != "overall") {
                    summary_payload.data_type = dataType;
                    summary_payload.project_id = parseInt(selectedProject);
                } else if (dataType == "overall" && projects?.length > 0) {
                    summary_payload.data_type = 'project_overall';
                    summary_payload.project_id = projectIDs;
                }
                if (companyID != -1) {
                    summary_payload.company_id = companyID;
                } else {
                    summary_payload.customer_username = customerUsername;
                }
                const resSummary = await axios.post(ENVIRONMENT.GET_SYSTEM_USAGE, summary_payload);
                if (resSummary.data) {
                    await handleDownloadMultipleCSV(resSummary.data, "summary_"+service, zip);
                }

                let detail_payload = {}
                detail_payload.request_type = service;
                detail_payload.date_filter_type = dateFilterType;
                detail_payload.action = 'get_details';
                if (companyID != -1) {
                    detail_payload.company_id = companyID;
                } else {
                    detail_payload.customer_username = customerUsername;
                }
                detail_payload.start_date = startDate;
                detail_payload.end_date = endDate;
                detail_payload.data_type = "overall";

                if (props.dataType != "overall") {
                    detail_payload.data_type =dataType;
                    detail_payload.project_id = parseInt(selectedProject);
                } else if (props.dataType == "overall" && projects?.length > 0) {
                    detail_payload.data_type = 'project_overall';
                    detail_payload.project_id = projectIDs;
                }
        

                try {
                    const res = await axios.post(ENVIRONMENT.GET_SYSTEM_USAGE, detail_payload);
                    if (res.data && service !== "managed_services") {
                        await handleDownloadMultipleCSV(res.data[service], service, zip);
                    }
                } catch (err) {
                    console.log(err);
                }
            }
        });


        Promise.all(promises).then(() => {
            zip.generateAsync({ type: 'blob' }).then((content) => {
                saveAs(content, startDate+'_'+endDate+'.zip');
                setTimeout(loader);
                setExportedDataLoader(false);
            });
        }).catch(err => {
            console.log(err);
            setExportedDataLoader(false);
        });
    }

    const selectDataType = (value) => {
        if (value === -1) {
            setDataType("overall");
            setSelectedProject(value);
        } else {
            setDataType("project");
            setSelectedProject(value);
        }
    }

    return (
        <>
            <Row className="justify-space-between" style={{ marginTop: "20px", marginBottom: 20 }}>
                <Col span={24} className='justify-space-between'>
                    <Col span={6}>
                        <div className='manrope f-24 w-700' style={{ display: 'flex', alignItems: "center" }}>
                        <img src={`${process.env.PUBLIC_URL}/img/back_arrow.png`} alt="Arrow Back" style={{cursor:'pointer',marginRight:5}} onClick={handlebackclick} />
                            Usage History
                        </div>
                    </Col>
                    <Col span={18} className="justify-in-end">
                        <div className='manrope f-14 black-55' style={{ marginRight: 8 }}>
                            Date Filter
                        </div>
                        <RangePicker size={"large"} defaultValue={[moment(startDate, DATE_FORMAT), moment(endDate, DATE_FORMAT)]}
                            format={DATE_FORMAT} className="date-picker" popupStyle={{ fontFamily: 'Manrope', fontSize: 14, color: "#40a9ff", background: "#e6efff" }} placeholder={['Date (From)', 'Date (To)']}
                            renderExtraFooter={() => <p className='date-footer'><InfoCircleOutlined />&nbsp; {FileConstants.DATE_FILTER_INFO[tabKey]}</p>}
                            value={[moment(startDate, DATE_FORMAT), moment(endDate, DATE_FORMAT)]}
                            onCalendarChange={val => onCalenderChange(val)} />

                        <Select
                            className="manrope f-14 black-55 tree-select-material"
                            placeholder="Filter By Date"
                            onChange={onChangeDateType}
                            defaultValue={"billing_date"}
                            defaultActiveFirstOption={true}
                            style={{ width: 160, marginLeft: 10 }}
                            dropdownMatchSelectWidth={false}
                            placement={"bottomRight"}
                            options={FileConstants.DATE_FILTERS_ADMIN} />
                            {projects?.length > 0 && 
                            <Select  defaultValue={-1} style={{ width: 160, marginLeft: 10 }} className="manrope f-14 black-55 tree-select-material" placeholder="Select Data Type"
                                showArrow onSelect={e => selectDataType(e)}>
                                <Option value={-1} className="manrope f-16 select-view">Overall</Option>
                                {projects.map(project => <Option value={project.id} className="manrope f-16 select-view">{project.name}</Option>)}
                            </Select>}
                            <Button 
                            className="modal-okay square font-16 ml-10"
                            onClick={exportedData}
                            disabled={exportedDataLoader || !displayData || summaryLoader}
                            loading={exportedDataLoader}>Export to CSV</Button>
                    </Col>
                </Col>
            </Row>

            <Collapse
                destroyInactivePanel={false}
                defaultActiveKey={collapseKey} style={{ marginTop: 32 }} className="collapse-panel bg-df" ghost
                expandIconPosition={'right'}>
                <Panel
                    forceRender={true}
                    style={{ marginBottom: 10 }}
                    header={<span className="manrope f-16 black-55 w-700">Summary &nbsp; <Tooltip
                        title={<span className='manrope f-14 white'>This summary is only for your Usage.</span>}>
                        <InfoCircleOutlined />
                    </Tooltip></span>}
                    key={"summary"}>
                    <SystemUsageSummary
                        setRequestTypeCount={setRequestTypeCount}
                        setError={setError}
                        setTypeLoading={setTypeLoading}
                        requestTypeCount={requestTypeCount}
                        error={error}
                        typeLoading={typeLoading}
                        projectIDs={projectIDs}
                        projects={projects}
                        selectedProject={selectedProject}
                        prepareSystemUsageCounts={prepareSystemUsageCounts}
                        dataType={dataType}
                        summaryLoader={summaryLoader}
                        setSummaryLoader={setSummaryLoader}
                        totalCount={totalCount}
                        setTotalCount={setTotalCount}
                        display_data={displayData}
                        date_filter_type={dateFilterType}
                        username={customerUsername}
                        company_id={companyID}
                        start_date={startDate}
                        end_date={endDate} />
                </Panel>
                <Panel
                    forceRender={true}
                    style={{ marginBottom: 10 }}
                    header={<span className="manrope f-16 black-55 w-700">Details</span>}
                    key={"details"}>
                    <Tabs onChange={onChangeTab}
                        style={{ marginTop: 20, marginLeft: 10, marginRight: 10 }} defaultActiveKey={['usage_details']} className="product-tab library" tabBarGutter={16} size="large">
                        <TabPane tab={`${IS_MS_PROVIDER && (MANAGED_CUSTOMER_USERNAME != null) ? MANAGED_CUSTOMER_USERNAME + "'s" : "Your"} Usage`} key={"usage_details"} style={{ padding: "10px" }}>
                            <SystemUsage
                                setError={setError}
                                setTypeLoading={setTypeLoading}
                                error={error}
                                typeLoading={typeLoading}
                                projectIDs={projectIDs}
                                projects={projects}
                                selectedProject={selectedProject}
                                dataType={dataType}
                                summaryLoader={summaryLoader}
                                totalCount={totalCount}
                                display_data={displayData}
                                date_filter_type={dateFilterType}
                                start_date={startDate}
                                end_date={endDate}
                                username={customerUsername}
                                account_type={accountType}
                                company_id={companyID}
                                requestTypeCount={requestTypeCount} />
                        </TabPane>

                        {/* Commenting code for now - might need it later */}
                        {/* <TabPane tab={'Managed Services'} key={"managed_services"} style={{ padding: "10px" }}>
                            <ManagedServices start_date={startDate} end_date={endDate}
                                account_type={accountType}
                                usage_type={companyID == -1 ? "customer" : "company"}
                                data_value={companyID == -1 ? customerUsername : companyID} />
                        </TabPane> */}

                        <TabPane tab={'Shared Items'} key={"shared_items"} style={{ padding: "10px" }}>
                            <SharedItemUsage
                                display_data={displayData}
                                date_filter_type={dateFilterType}
                                start_date={startDate}
                                end_date={endDate}
                                username={customerUsername}
                                account_type={accountType}
                                company_id={companyID} />
                        </TabPane>
                    </Tabs>
                </Panel>
            </Collapse>
        </>
    );

}

export default withRouter(CustomerAccountUsage);
